import React from "react";
import "./checkoutcard.css";
import DeleteCartItemBtn from "../DeleteCartItemBtn/DeleteCartItemBtn";

const CheckoutCard = ({ image, product }) => {
  return (
    <div className="checkoutcard">
      
      {/* LEFT — IMAGE */}
      <div className="checkoutcard-left">
        <img
          className="checkoutcard-image"
          src={image}
          alt={product?.product?.name}
        />
      </div>

      {/* RIGHT — DETAILS */}
      <div className="checkoutcard-right">

        <div className="checkoutcard-title">{product?.product?.name}</div>

        <div className="checkoutcard-subrow">
           {product?.purity}
        </div>

        <div className="checkoutcard-subrow">
          {product.diamondtype === "lab grown" ? "LGD" : "NATURAL"}  | {product?.quality}
        </div>

        <div className="checkoutcard-subrow">
         {product?.color}
        </div>

        <div className="checkoutcard-subrow">
         {product?.quantity} {product?.quantity > 1 ? "pcs" : "pc"}
        </div>

        <div className="checkoutcard-price">₹ {product?.livePrice}</div>

        {/* DELETE BUTTON */}
        {/* <DeleteCartItemBtn
          styleclass={"deletebutton-checkout"}
          cartid={product._id}
          productid={product.product._id}
          quantity={product.quantity}
        /> */}
      </div>
    </div>
  );
};

export default CheckoutCard;
